import React from 'react'
import FormContact from '../components/FormContact'
import NetworkContact from '../components/NetworkContact'

function contact() {
  return (
    <>
        <NetworkContact/>
        <FormContact/>
    </>
  )
}

export default contact